export interface BetConfigEntry {
	min_bet_size: number
	max_bet_size: number
}

export interface CalculatedExposureDto {
	betId: string
	marketId: string
	selectionId: string
	side: 'back' | 'lay'
	price: number
	betSize: number
	stakeMatched: number
}

export class Bet {
	bet_id: string

	market_id: string

	selection_id: string

	side: 'back' | 'lay'

	price: number

	bet_size: number

	size_matched: number

	potential_profit!: number

	potential_loss!: number

	constructor(betId: string, marketId: string, selectionId: string, side: 'back' | 'lay', price: number, betSize: number, stakeMatched: number) {
		this.bet_id = betId
		this.market_id = marketId
		this.selection_id = selectionId
		this.side = side
		this.price = parseFloat(price.toString())
		this.bet_size = parseFloat(betSize.toString())
		this.size_matched = parseFloat(stakeMatched.toString())

		this.calculatePotentialOutcomes()
	}

	calculatePotentialOutcomes() {
		if (this.side === 'back') {
			this.potential_profit = this.bet_size * (this.price - 1)
			this.potential_loss = this.bet_size
		} else {
			this.potential_profit = this.bet_size
			this.potential_loss = this.bet_size * (this.price - 1)
		}
	}

	static fromDto(dto: CalculatedExposureDto): Bet {
		return new Bet(dto.betId, dto.marketId, dto.selectionId, dto.side, dto.price, dto.betSize, dto.stakeMatched)
	}
}
